import storage from '../storage';

const REGIONS_STORAGE_KEY = 'user_regions';
const DEFAULT_REGION_STORAGE_KEY = 'user_region';

/**
 * Получить сохраненные регионы из localStorage
 * @returns {Array} Массив регионов или пустой массив
 */
export const getStoredRegions = () => {
  try {
    const stored = storage.getItem(REGIONS_STORAGE_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn('Failed to parse stored regions:', error);
    return [];
  }
};

/**
 * Сохранить регионы в localStorage
 * @param {Array} regions - Массив регионов для сохранения
 */
export const setStoredRegions = (regions) => {
  try {
    storage.setItem(REGIONS_STORAGE_KEY, JSON.stringify(regions));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn('Failed to store regions:', error);
  }
};

/**
 * Получить сохраненный основной регион из localStorage
 * @returns {Object|null} Объект региона или null
 */
export const getStoredDefaultRegion = () => {
  try {
    const stored = storage.getItem(DEFAULT_REGION_STORAGE_KEY);
    return stored ? JSON.parse(stored) : null;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn('Failed to parse stored default region:', error);
    return null;
  }
};

/**
 * Сохранить основной регион в localStorage
 * @param {Object} region - Объект региона для сохранения
 */
export const setStoredDefaultRegion = (region) => {
  try {
    storage.setItem(DEFAULT_REGION_STORAGE_KEY, JSON.stringify(region));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn('Failed to store default region:', error);
  }
};

/**
 * Получить все города России из списка городов
 * @param {Array} cities - Массив всех городов
 * @returns {Array} Массив городов России
 */
export const getRussianCities = (cities) => {
  if (!cities || !Array.isArray(cities)) {
    return [];
  }

  return cities.filter((city) => city.country && city.country.name === 'Россия');
};

/**
 * Создать объект региона из города
 * @param {Object} city - Объект города
 * @returns {Object} Объект региона
 */
export const createRegionFromCity = (city) => ({
  city: city.name,
  country_id: city.country.id,
  country_name: city.country.name,
  country_currency: city.country.currency || 'RUB',
  country_currency_symbol: city.country.currency_symbol || '₽',
});

/**
 * Получить регионы для отображения (из localStorage или все города России)
 * @param {Array} cities - Массив всех городов
 * @returns {Object} Объект с user_regions и user_region
 */
export const getRegionsForDisplay = (cities) => {
  const storedRegions = getStoredRegions();
  const storedDefaultRegion = getStoredDefaultRegion();

  // Если есть сохраненные регионы, используем их
  if (storedRegions.length > 0) {
    return {
      user_regions: storedRegions,
      user_region: storedDefaultRegion || storedRegions[0],
    };
  }

  // Если нет сохраненных регионов, выбираем все города России
  const russianCities = getRussianCities(cities);
  if (russianCities.length > 0) {
    const russianRegions = russianCities.map(createRegionFromCity);
    return {
      user_regions: russianRegions,
      user_region: russianRegions[0],
    };
  }

  // Если нет городов России, возвращаем пустые массивы
  return {
    user_regions: [],
    user_region: null,
  };
};

/**
 * Сохранить выбранные регионы
 * @param {Array} selectedCities - Массив выбранных городов
 */
export const saveSelectedRegions = (selectedCities) => {
  if (!selectedCities || selectedCities.length === 0) {
    return;
  }

  const regions = selectedCities.map(createRegionFromCity);
  const defaultRegion = regions[0];

  setStoredRegions(regions);
  setStoredDefaultRegion(defaultRegion);
};



// WEBPACK FOOTER //
// ./src/utils/regionStorage.js